// Pure helpers extracted from ProductDialog so the dialog component stays
// small and the validation/payload logic is independently testable.
import { uid } from "../../lib/storage";

export const EMPTY_PRODUCT = {
  name: "",
  category: "",
  unit: "ea",
  supplierId: "",
  par: 0,
  costPerUnit: 0,
  image: "",
  assignedAreas: [],
  assignedRestaurants: ["restaurant_1", "restaurant_2"],
  availableForPurchase: true,
  availableForTransfer: true,
  active: true,
  ownerRestaurant: "global",
};

// Returns null when valid, otherwise an error message ready to toast.
export function validateProduct(form) {
  const name = form.name.trim();
  if (!name) return "Name is required";
  if (!form.supplierId) return "Pick a vendor";
  if (!form.category) return "Pick a category";
  if (!(form.assignedRestaurants || []).length) return "Assign to at least one restaurant";
  return null;
}

export function buildProductPayload(form, existing) {
  const nowIso = new Date().toISOString();
  return {
    ...form,
    id: existing?.id || uid("p"),
    name: form.name.trim(),
    par: Number(form.par) || 0,
    costPerUnit: Math.max(0, Number(form.costPerUnit) || 0),
    unit: form.unit.trim() || "ea",
    updatedAt: nowIso,
    createdAt: existing?.createdAt || nowIso,
  };
}
